// Composables
import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/testing',
    component: () => import('@/layouts/default/Default.vue'),
    children: [
      // {
      //   path: '',
      //   name: 'Home',
      //   component: () => import(/* webpackChunkName: "home" */ '@/views/Home.vue'),
      // },
      {
        path:'/logout',
        name:'logout',
        component: () => import('@/views/pages/logout.vue')
      },
      {
        path:'/',
        name:'resturant',
        component: () => import('@/views/pages/restaurant/index.vue')
      },
      {
        path:"/resturant-checkout",
        name:"resturant-checkout",
        component: () => import('@/views/pages/restaurant/checkout.vue')
      },
      {
        path:'/dashboard',
        name:'dashboard',
        component: () => import('@/views/pages/user/index.vue')
      },
      {
        path:'/profile',
        name:'profile',
        component: () => import('@/views/pages/user/profile.vue')
      },
      {
        path:'/orders',
        name:'orders',
        component: () => import('@/views/pages/orderHistory/index.vue')
      },
      {
        path:'/order-tracking/:lat/:lang/:driverId',
        name:'orderTracking',
        component: () => import('@/views/pages/orderHistory/order_track.vue')
      },
      {
        path:'/qr-code/:table_id',
        name:'qrCode',
        component: () => import('@/views/pages/restaurants_QR/index.vue')
      },
      {
        path:'/qr-code/checkout/:table_id',
        name:'qrCodeCheckout',
        component: () => import('@/views/pages/restaurants_QR/checkOut.vue')
      },
      {
        path:'/qr-order-success/:tb_id',
        name:'AfterQrOrderSuccess',
        component: () => import('@/views/pages/restaurants_QR/afterOrder.vue')
      },
      {
        path:'/privacy',
        name:'privacy',
        component: () => import('@/views/pages/privacy/index.vue')
      },
      {
        path:'/about-us',
        name:'aboutUs',
        component: () => import('@/views/pages/aboutUs/index.vue')
      },
      {
        path:'/terms-condition',
        name:'termsCondition',
        component: () => import('@/views/pages/termsCondition/index.vue')
      },
      {
        path:'/company-details',
        name:'CompanyDetails',
        component: () => import('@/views/pages/companyDetails/index.vue')
      },
      {
        path:'/return-refunds',
        name:'returnRefunds',
        component: () => import('@/views/pages/returnsRefunds/index.vue')
      },
      {
        path:'/login',
        name:'Login',
        component: () => import('@/views/pages/auth/login.vue')
      },
      {
        path:'/register',
        name:'Register',
        component: () => import('@/views/pages/auth/register.vue')
      },
      {
        path:'/feedback',
        name:'feedback',
        component: () => import('@/views/pages/feedback/index.vue')
      },
      {
        path:'/order-status',
        name:'OrderStatus',
        component: () => import('@/views/pages/orderStatus/index.vue')
      },
      {
        path:'/driver-signup',
        name:"DriverSignup",
        component: () => import('@/views/pages/driver/signup.vue')
      } 
    ],
  },
 

  
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

export default router
